<nav class="navbar navbar-expand-lg navbar-light bg-light primary">
	<span class="navbar-brand"><img src="../../assets/images/nesten-logo.png" alt="" class="img-fluid" style="height: 40px;"></span>
	<span class="headerSpace"></span>
	<i class="fa fa-bars" aria-hidden="true" (click)="openDialog()" style="font-size: x-large; cursor:pointer;"></i>
</nav>
<div class="main-div">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-md-6">
        <h2 class="title">Send</h2>
				<div class="form-holder">

					<div class="col" *ngIf="!helper.globalPause && helper.receipt == ''">
						<mat-form-field class="example-full-width">
							<input class="primary" matInput [(ngModel)]="data.to"  placeholder="Receiver address">
						</mat-form-field>
					</div>

					<div class="col" style="padding-top: 15px;" *ngIf="!helper.globalPause && helper.receipt == ''">
						<mat-form-field class="example-full-width">
							<input type = "text" matInput class="primary " [(ngModel)]="data.value" placeholder="Value" (ngModelChange)="checkData($event)">
						</mat-form-field>
					</div>

					<div class="col" *ngIf="helper.receipt">
						<p style="color: green" class="text-center">Transaction Successful</p>
						<p class="text-white text-center"> Included in Block Number - {{helper.receipt.blockNumber}}
						<p>
						<!-- TransactionHash - {{helper.receipt.transactionHash}} -->
					</div>

					<div class="col">

						<div class="spinDiv w-100">
							<div *ngIf="helper.globalPause">
								<mat-spinner class="mat-spinner-color"></mat-spinner>
								<div class="text-white">Processing...</div>
							</div>
						</div>

						<a href="https://explorer.nitwallet.io/tx/{{helper.receipt.transactionHash}}" target="blank" *ngIf="helper.receipt" class="mb-2">
							<button href="" mat-stroked-button class="info mb-2">
								View Details on NIT explorer
							</button>
						</a>
							<div class="row mb-4 justify-content-between" style="padding-top: 20px">
								<div class="col-md-4 mb-2">
										<button mat-stroked-button class="primary solid-gradient-btn btn-block" (click)="backToDashboard()">Back</button>
								</div>
								<div class="col-md-4 mb-2" *ngIf="!helper.receipt" >
                  <button mat-stroked-button class="primary solid-gradient-btn btn-block" (click)="sendNit()" >Send</button>
                </div>
                <div class="col-md-4 mb-2" *ngIf="helper.receipt">
                  <button mat-stroked-button class="primary solid-gradient-btn" (click)="route('txhistory')">Tx History</button>
                </div>
							</div>
					</div>

				</div>
			</div>
		</div>
	</div>

</div>
